export const environment = {
  production: true,
  imageBaseUrl: 'https://media.ud4.ru/img',
  api: 'https://api.ud4.ru/v2/wg',
  apiProxyHosts: [
    'https://api.ud4.ru',
    'https://api1.ud4.ru',
    'https://api2.ud4.ru',
  ],
  apiPingRequestAddress: 'v1/app/availableAuthTypes',
  apiUrlSuffix: 'v2/wg',
  controlRequestTimeout: 30000,
  controlRequestInterval: 1800000,
  controlRequestLockTTLMs: 40000,
  // Начальное окно ожидания (grace) от старта фонового ping: пока пригодного snapshot ещё
  // нет, запрос/UI ждёт публикацию результата не дольше этого времени, после чего работает
  // по сохранённому порядку URL. Не даёт плашке «Поиск сети» висеть весь controlRequestLockTTLMs.
  controlRequestGraceMs: 1500,
  //таймаут на connection.start() (negotiate + установка транспорта) в startHubWithFallback —
  //без него зависший (не отвечающий, но не рвущий соединение) хост блокирует переход к
  //следующему в пуле; сам SignalR такого таймаута не даёт (withServerTimeoutInMilliseconds
  //действует только после уже установленного соединения)
  hubConnectTimeoutMs: 30000,
  apiClear: 'https://api.ud4.ru/',
  apiClearUrlSuffix: '',
  widgetHost: 'https://wg.ud4.ru',
  widgetIdInApp: '0cc480b993a1452f962d9652838c8113',
  vkAuthAppId: '52812109',
  vkAppIds: {
    rooms: '6445829',
    schedule: '6277910',
    subscriptions: '6445819',
    courses: '6486550',
    coaches: '6486553',
  },
  vkIdUrl: 'https://id.vk.ru',
  siteBaseUrl: 'https://sportpriority.ud4.ru/',
  offerUrl: 'https://sportpriority.com/user-agreement/',
  politicsUrl: 'https://sportpriority.com/privacy-policy/',
  personalDataConsentUrl:
    'https://sportpriority.com/privacy-policy/#soglasieSP',
  paymentBaseUrl: 'https://sp-pay.ud4.ru/',
  paymentUrl: 'https://sp-pay.ud4.ru/pay-widget',
  paymentCertUrl: 'https://sp-pay.ud4.ru/pay-certwg',
  externalPaymentUrl: 'https://sp-pay.ud4.ru/pay-app/',
  externalPaymentSbpUrl: 'https://sp-pay.ud4.ru/pay-app-sbp/',
  paymentProxyHosts: ['https://sp-pay.ud4.ru', 'https://sp-pay1.ud4.ru'],
  paymentPingRequestAddress: 'ping',
  paymentBaseUrlSuffix: '',
  paymentUrlSuffix: 'pay-widget',
  paymentCertUrlSuffix: 'pay-certwg',
  externalPaymentUrlSuffix: 'pay-app/',
  externalPaymentSbpUrlSuffix: 'pay-app-sbp/',
};
